export default __webpack_public_path__ + "static/media/right-mobile-purple.462cb414.svg";